export const textEn =
  {
    titg1: "1. Indicators Installation",
    titg1_01: "Standart Installation",
    subg1_01: "",
    urlg1_01: "H1mja0bI2vY?list=PLIm0iS26oKOQgGG__9ELGElfHLDPDI-kI",
    titg1_02: "Installation with Exceptions (Recommended)",
    subg1_02: "In certain cases, antivirus software may identify files as false positives. To solve this problem, it is recommended to follow these steps:",
    urlg1_02: "YT4Meqk3egM?list=PLIm0iS26oKOQgGG__9ELGElfHLDPDI-kI",
    titg1_03: "Uninstall Indicators",
    subg1_03: "",
    urlg1_03: "YM2Ffjs64MI?list=PLIm0iS26oKOQgGG__9ELGElfHLDPDI-kI",
    titg2: "2. Common Errors",
    titg2_01: "Error: Indicator does not load - 'DLL Error'",
    subg2_01: "The indicators do not appear on the chart, and a 'DLL Error' appears in the Log window.",
    urlg2_01: "s2NjDTDXPYU?list=PLIm0iS26oKOQgGG__9ELGElfHLDPDI-kI",
    titg2_02: "Error: Indicator does not load - 'NO DLL Error Produced'",
    subg2_02: "The indicators do not appear on the chart, but no 'DLL Error' is produced.",
    urlg2_02: "8ZxzfS035SI?list=PLIm0iS26oKOQgGG__9ELGElfHLDPDI-kI",
  };



export const textEs =
  {
    titg1:"1. Instalación de indicadores",
    titg1_01:"Instalación normal",
    subg1_01: "",
    urlg1_01: "meZ48zcoBSk?list=PLIm0iS26oKOQNrpqmDwQXMPE9wTJis8cI",
    titg1_02:"Instalación con excepciones (recomendada)",
    subg1_02: "En ciertos casos, el software antivirus puede identificar los archivos como falsos positivos. Para solucionar este problema, se recomienda seguir estos pasos:",
    urlg1_02: "Op382KhsIpk?list=PLIm0iS26oKOQNrpqmDwQXMPE9wTJis8cI",
    titg1_03:"Desinstalar indicadores",
    subg1_03: "",
    urlg1_03: "LtkiFfPEQX4?list=PLIm0iS26oKOQNrpqmDwQXMPE9wTJis8cI",
    titg2:"2. Errores Comunes",
    titg2_01:"Error: El indicador no carga - 'Error DLL'",
    subg2_01: "Los indicadores no se muestran en el gráfico y en la ventana de Log aparece un 'Error DLL'.",
    urlg2_01: "dJqkmFge_Mw?list=PLIm0iS26oKOQNrpqmDwQXMPE9wTJis8cI",
    titg2_02:"Error: El indicador no carga - 'NO produce Error DLL'",
    subg2_02: "Los indicadores no se muestran en el gráfico, pero no se produce el 'Error DLL'.",
    urlg2_02: "CU3v9RXiz68?list=PLIm0iS26oKOQNrpqmDwQXMPE9wTJis8cI",
  };
